import { render } from "./ManagementCompany.vue?vue&type=template&id=7b4c0ae2"
import script from "./ManagementCompany.vue?vue&type=script&lang=js"
export * from "./ManagementCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__